import { render, staticRenderFns } from "./SourceInputs.vue?vue&type=template&id=2bcb9536"
import script from "./SourceInputs.vue?vue&type=script&lang=js"
export * from "./SourceInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports